import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "../ui/Tooltip";

interface NavTooltipProps {
    button: any;
    text: string;
}

export default function MapTooltip({ button, text }: NavTooltipProps) {
    return (
        <TooltipProvider>
            <Tooltip delayDuration={100}>
                <TooltipTrigger asChild>{button}</TooltipTrigger>
                <TooltipContent
                    side="left"
                    align="center"
                    sideOffset={8}
                    className="text-[11px]"
                >
                    {text}
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
